export default __webpack_public_path__ + "static/media/sb-icon-active.5890b6f5.svg";